/**
 * @generated SignedSource<<f7e9893e56d6689b9fc7a987d53740cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeType = "BOOLEAN" | "DATE" | "INTEGER" | "STRING" | "%future added value";
export type MailingListCriterionFieldsAttributeDefinitionsQuery$variables = Record<PropertyKey, never>;
export type MailingListCriterionFieldsAttributeDefinitionsQuery$data = {
  readonly attributeDefinitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityTypes: ReadonlyArray<string>;
        readonly id: string;
        readonly label: string;
        readonly name: string;
        readonly type: AttributeType;
      } | null | undefined;
    }>;
  };
};
export type MailingListCriterionFieldsAttributeDefinitionsQuery = {
  response: MailingListCriterionFieldsAttributeDefinitionsQuery$data;
  variables: MailingListCriterionFieldsAttributeDefinitionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AttributeDefinitionConnection",
    "kind": "LinkedField",
    "name": "attributeDefinitions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AttributeDefinitionEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AttributeDefinition",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entityTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MailingListCriterionFieldsAttributeDefinitionsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MailingListCriterionFieldsAttributeDefinitionsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9c11eafd488d192d3422c2a7a5eba101",
    "id": null,
    "metadata": {},
    "name": "MailingListCriterionFieldsAttributeDefinitionsQuery",
    "operationKind": "query",
    "text": "query MailingListCriterionFieldsAttributeDefinitionsQuery {\n  attributeDefinitions {\n    edges {\n      node {\n        id\n        name\n        label\n        type\n        entityTypes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "951fc55326dc89725bfbb87057f3dd7f";

export default node;
